import {
  Grid,
  TextField,
  MenuItem,
  Box,
  Typography,
  IconButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Card } from "react-bootstrap";
import React, { useState, useContext, useEffect } from "react";
import PsContext from "../../context";
import { _LIST_TASK_CATEGORIES } from "../../models/task";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import WidgetsIcon from "@mui/icons-material/Widgets";
import { MuiModalWindow } from "../../utils";
import EditCategory from "./editCategory";
import AddCategory from "./addCategory";

const ViewTaskCategories = (props) => {
  const context = useContext(PsContext);

  const [selCategory, setSelCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    listCategory();
  }, []);

  const listCategory = () => {
    setCategories([]);

    _LIST_TASK_CATEGORIES()
      .then((res) => {
        setCategories(res.data);

        if (res.data.length == 0) {
          Toast.show({
            icon: "fail",
            content: res.message ? res.message : "No Data",
          });
        }
      })
      .catch((error) => {
        console.error("Error listing categories:", error);
        Toast.show({
          icon: "fail",
          content: "No Data.",
        });
      });
  };

  const handleEdit = (cat) => {
    setSelCategory(cat);
    setShowEditModal(true);
  };

  return (
    <>
      <Card>
        <Card.Header className="card-header-bg fw-bold text-uppercase">
          {"VIEW CATEGORIES"}

          <span className="float-end p-0 m-0">
            <IconButton
              color="primary"
              onClick={props.goBackToDashboard}
              aria-label="go-to-dashboard"
              className="p-0 m-0 me-2"
            >
              <WidgetsIcon />
            </IconButton>
            <IconButton
              color="primary"
              onClick={() => setShowModal(true)}
              aria-label="add-task"
              className="p-0 m-0"
            >
              <AddIcon />
            </IconButton>
          </span>
        </Card.Header>
      </Card>

      <TableContainer component={Paper} sx={{ marginTop: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Category Name</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {categories.map((category, index) => (
              <TableRow key={category.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{category.category_name}</TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => handleEdit(category)}
                    color="primary"
                  >
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <MuiModalWindow
        open={showModal}
        onClose={(e) => setShowModal(false)}
        title="Add Category"
      >
        <AddCategory
          onSuccess={(e) => {
            setShowModal(false);
            listCategory();
          }}
        />
      </MuiModalWindow>

      <MuiModalWindow
        open={showEditModal}
        onClose={(e) => setShowEditModal(false)}
        title="Edit Category"
      >
        <EditCategory
          dataSource={selCategory}
          onSuccess={(e) => {
            setSelCategory(null);
            setShowEditModal(false);
            listCategory();
          }}
        />
      </MuiModalWindow>
    </>
  );
};

export default ViewTaskCategories;
